/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { queryFormEditable, State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { getPbCostCenterId, PbCostCenter } from '../../../resources/price-book.model';
import { PbCommandService } from '../pb-command.service';
import {
  PbDetailsState,
  queryExistingCostCenters,
  queryPbCostCenterHasItems,
  querySelectedCostCenterId,
} from '../pb-details.state';
import { PBDetailsCcGridDefinition } from './pb-details-cc-grid-definition.service';

@Component({
  selector: 'gh-pb-details-cc-list',
  template: require('./pb-details-cc-list.component.html'),
  styles: [require('./pb-details-cc-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PBDetailsCcGridDefinition],
})
export class PBDetailsCcListComponent implements OnInit {
  editable: boolean = true;
  costCenters$: Observable<PbCostCenter[]>;
  selectedCostCenterId$: Observable<Maybe<ID>>;

  constructor(public gridDefinition: PBDetailsCcGridDefinition,
              private state: State<PbDetailsState>,
              private commands: PbCommandService) {

  }

  ngOnInit(): void {
    this.costCenters$ = this.state.select(queryExistingCostCenters);
    this.editable = queryFormEditable(this.state.value);
    this.selectedCostCenterId$ = this.state.select(querySelectedCostCenterId);
  }

  onAdd(): void {
    this.commands.costCenterAdd();
  }

  onDelete(costCenter: PbCostCenter): void {
    this.commands.costCenterRemove(costCenter);
  }

  canBeRemoved$(costCenter: PbCostCenter): Observable<boolean> {
    return this.state.select((s) => !queryPbCostCenterHasItems(s, getPbCostCenterId(costCenter)));
  }

  onSelectedCostCenterChanged(id?: ID): void {
    this.commands.costCenterSelect(id);
  }
}
